import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/home/runner/work/waitlistly/waitlistly/node_modules/@vercel/analytics/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/home/runner/work/waitlistly/waitlistly/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/waitlistly/waitlistly/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/runner/work/waitlistly/waitlistly/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationProvider"] */ "/home/runner/work/waitlistly/waitlistly/src/contexts/NavigationContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/waitlistly/waitlistly/src/styles/index.css");
